// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { getImageCss, productImageCarouselStyles } from "@cahaba/Overrides/Components/ProductImageCarousel";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productImageCarouselStyles.carouselGridItem = { width: 12 };

productImageCarouselStyles.carouselSlideInner = {
    css: css`
        width: 100%;
        text-align: center;
        position: relative;
        padding: 0 3px 0;
        height: 100%;
        display: flex;
        justify-content: center;
    `,
};

productImageCarouselStyles.image = {
    css: css`
        ${getImageCss}
    `,
};

productImageCarouselStyles.selectedImage = {
    css: css`
        ${getImageCss}
    `,
};

productImageCarouselStyles.imageClickable = {
    css: css`
        border: 1px solid ${getColor("common.border")};
        height: 100%;
        :focus {
            outline: none;
        }
    `,
};

productImageCarouselStyles.selectedImageClickable = {
    css: css`
        border: 1px solid rgb(0, 153, 255);
        height: 100%;
        :focus {
            outline: none;
        }
    `,
};

productImageCarouselStyles.slidesContainer = {
    css: css`
        transform: none;
        margin-left: -3px;
        flex-wrap: wrap;
    `,
};

productImageCarouselStyles.slide = {
    css: css`
        flex: 0 0 80px;
    `,
};
